<template>
  <div
    class="products-skeleton"
    aria-busy="true"
    aria-live="polite"
    aria-label="Cargando catálogo"
  >
    <div class="products-skeleton__pagination" aria-hidden="true">
      <span
        v-for="n in paginationDots"
        :key="'page-' + n"
        class="products-skeleton__page-dot"
      />
    </div>
    <div class="row">
      <div
        class="col-sm-6 col-md-4 col-lg-4"
        v-for="n in cardCount"
        :key="'card-' + n"
      >
        <div class="products-skeleton__card">
          <div class="products-skeleton__image" />
          <div class="products-skeleton__body">
            <div class="products-skeleton__line products-skeleton__line--title" />
            <div class="products-skeleton__line products-skeleton__line--title-short" />
            <div class="products-skeleton__stars" />
            <div class="products-skeleton__line products-skeleton__line--price" />
            <div class="products-skeleton__button" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductsSkeleton',
  props: {
    cardCount: { type: Number, default: 12 },
    paginationDots: { type: Number, default: 5 },
  },
};
</script>

<style lang="scss" src="./ProductsSkeleton.scss"></style>
